/**
 * api接口的统一出口
 */
// 验证模块接口
import auth from '../api/auth';
// 商品模块接口
import good from '../api/good';
//菜单模块接口
import menu from '../api/menu';
//筛选模块接口
import filter from '../api/filter';
//我的最爱模块接口
import favor from '../api/favor';
import sort from '../api/sort';
import order from '../api/order';
import info from '../api/info';

import vendeurs from '../api/vendeurs';
import help from '../api/help';
import home from '../api/home';
import admin from "@/api/admin";

// 其他模块的接口……

// 导出接口
export default {
    auth,
    good,
    menu,
    filter,
    favor,
    sort,  //分类
    order,//订单
    vendeurs,//商家
    info,//买家信息
    help,//常见问题与回答
    home,//买家主页
    admin,//管理员的接口
    // ……
}
